import { accountActions } from './';
import accountServices from './services';
import { config } from 'config';
import { dashboardActions } from 'core/Dashboard';
import i18n from 'i18nextInstance';
import { isPathAvailable } from 'core/router.config';
import { push } from 'react-router-redux';
import {
    call,
    put,
    select,
    takeEvery
} from 'redux-saga/effects';
const {
    urlPatient,
    urlProfessional
} = config;

function* _changeProfile ({ payload }) {
    try {
        const { data } = yield call(accountServices.createOtt);
        const baseUrl = payload === 'patient' ? urlPatient : urlProfessional;
        window.open(`${ baseUrl }/acceso?mode=ott&key=${ data?.ott?.token_hash }&role_selected=true`, '_blank');
    } catch (err) {
        window.open(baseUrl, '_blank');
    }
}

function* _checkToken () {
    try {
        const { account: { token } } = yield select();
        if (token) {
            yield call(accountServices.validateToken);
        }
    } catch (err) {
        yield put(accountActions.logoutAccount());
    }
}

function* _checkVersion () {
    try {
        const { data: version_number } = yield call(accountServices.getVersion);
        yield put(accountActions.setAccountVersion(version_number));
    } catch (e) {

    }
}

function* _loginAccount ({ payload }) {
    try {
        yield put(accountActions.setAccountLoginExternalStatus('validating'));
        const { redirect, role_selected, source = 'login', token: hash } = payload;
        const { data } = source === 'login'
            ? yield call(accountServices.login, null, payload)
            : yield call(accountServices.getCheckExternalToken, null, { ott: hash, role: 'admin' });
        const { locked_actions, restricted_access, roles, token, user } = data;
        yield put(accountActions.setAccountToken(token));
        const newUser = {
            ...user,
            locked_actions: (locked_actions ?? []).map(({ name }) => name),
            restricted_access,
            role_selected: role_selected || (roles.length === 1 && roles[0] == 'admin'),
            roles: roles ?? []
        };
        yield put(accountActions.replaceAccountUser(newUser));
        yield put(dashboardActions.setDashboardSockets());
        if (redirect && isPathAvailable(redirect, newUser)) {
            yield put(push(redirect));
        } else {
            yield put(push('/'));
        }
        yield put(accountActions.setAccountLoginExternalStatus('success'));
    } catch (e) {
        yield put(accountActions.setAccountLoginExternalStatus('error'));
        if (e?.response?.status === 422) {
            if (e?.response?.data?.message === 'LOGIN_EXCEEDED_ATTEMPTS') {
                yield put(accountActions.setAccountError(i18n.t('Su usuario ha sido bloqueado por múltiples intentos de acceso')));
            } else {
                yield put(accountActions.setAccountError(i18n.t('El mail o la contraseña no son válidos')));
            }
        } else {
            yield put(accountActions.setAccountError(i18n.t('No fue posible conectarse con la plataforma')));
        }
    }
}

function* _logoutAccount () {
    try {
        yield put(accountActions.accountReset());
    } catch (e) {

    }
}

function* _resetPassword ({ payload }) {
    try {
        yield call(accountServices.getResetPassword, { identification: payload });
        yield put(push('/'));
    } catch (e) {
        yield put(accountActions.setAccountError(i18n.t('Email no válido')));
    }
}

export default [
    takeEvery(accountActions.changeProfile.type, _changeProfile),
    takeEvery(accountActions.checkToken.type, _checkToken),
    takeEvery(accountActions.checkVersion.type, _checkVersion),
    takeEvery(accountActions.loginAccount.type, _loginAccount),
    takeEvery(accountActions.logoutAccount.type, _logoutAccount),
    takeEvery(accountActions.resetPassword.type, _resetPassword)
];
